import axios from 'axios';
import qs from 'qs';
import { getFeedPickerConfig } from '../utils/feedPickerConfig';

export async function fetchFeedPickerHtml(params) {
    const { apiUrl } = getFeedPickerConfig();

    const response = await axios.get(apiUrl, {
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'brackets' }),
        responseType: 'text',
    });

    const html = response.data;

    // Magento exception приходит как HTML с этим текстом
    if (
        typeof html === 'string' &&
        (
            html.includes('Exception') ||
            html.includes('LocalizedException') ||
            html.includes('Некорректное значение')
        )
    ) {
        throw new Error('MAGENTO_EXCEPTION');
    }

    return html;
}
